class baoTabs extends HTMLElement {
  constructor () {
    super()
    this.tabs = []
    this.tabs = this.querySelectorAll('[role=tab]')
    this.tabsArr = Array.prototype.slice.call(this.tabs)
    this.tabpanels = []
    this.firstTab = null
    this.lastTab = null

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const urlTab = urlParams.get('tab')
    let urlTabRequested = null

    for (let i = 0; i < this.tabs.length; i += 1) {
      const tab = this.tabs[i]
      const tabpanel = document.querySelector(`#${tab.getAttribute('aria-controls')}`)
      tab.tabIndex = -1
      tab.setAttribute('aria-selected', 'false')
      this.tabpanels.push(tabpanel)
      tab.addEventListener('keydown', this.onKeydown.bind(this))
      tab.addEventListener('click', this.onClick.bind(this))
      if (!this.firstTab) {
        this.firstTab = tab
      }
      if (urlTab && urlTab === tab.getAttribute('data-tab-id')) {
        urlTabRequested = tab
      }
      this.lastTab = tab
    }

    if (urlTabRequested) {
      this.setSelectedTab(urlTabRequested, false)
    } else {
      this.setSelectedTab(this.firstTab, false)
    }
  }

  setSelectedTab (currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true
    }
    for (let i = 0; i < this.tabs.length; i += 1) {
      const tab = this.tabs[i]
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true')
        tab.removeAttribute('tabindex')
        this.tabpanels[i].closest('.shopify-section').classList.remove('tab-hidden')
        if (setFocus) {
          tab.focus()
        }
        const queryParam = new URLSearchParams(window.location.search)
        queryParam.set('tab', tab.getAttribute('data-tab-id'))
        history.replaceState(null, null, `?${queryParam.toString()}`)
      } else {
        tab.setAttribute('aria-selected', 'false')
        tab.tabIndex = -1
        this.tabpanels[i].closest('.shopify-section').classList.add('tab-hidden')
      }
    }
  }

  setSelectedToPreviousTab (currentTab) {
    let index
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index - 1])
    }
  }

  setSelectedToNextTab (currentTab) {
    let index
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index + 1])
    }
  }

  onKeydown (event) {
    const tgt = event.currentTarget
    let flag = false
    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt)
        flag = true
        break
      case 'ArrowRight':
        this.setSelectedToNextTab(tgt)
        flag = true
        break
      case 'Home':
        this.setSelectedTab(this.firstTab)
        flag = true
        break
      case 'End':
        this.setSelectedTab(this.lastTab)
        flag = true
        break
      default:
        break
    }

    if (flag) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onClick (event) {
    this.setSelectedTab(event.currentTarget)
  }
}
customElements.define('bao-tabs', baoTabs)
